export default __webpack_public_path__ + "static/media/white-google.f3bafd7a.svg";